import * as countryCodes from 'country-codes-list';
import { ICountryInfo } from '@dss-libs/shared/type/common-types';
import { getCountryFlagUrl } from './get-country-flag-url.utils';

/**
 * Gets list of countries with their country code, calling code, name and local name
 * @returns ICountryInfo[] - List of countries
 */
export function getCountriesInfo(): ICountryInfo[] {
  const list = countryCodes.customList(
    'countryCode' as countryCodes.CountryProperty,
    '["{countryCode}","{countryCallingCode}","{countryNameEn}","{countryNameLocal}"]'
  );
  const mappedValues = Object.values(list);
  const countries: ICountryInfo[] = [];
  for (const countryInfoString of mappedValues) {
    const [countryCode, countryCallingCode, countryNameEn, countryNameLocal] = JSON.parse(countryInfoString);
    // Netherlands Antilles islands and Antarctica are not countries and are not supported
    if (countryCode === 'AN' || countryCode === 'AQ') continue;
    countries.push({
      code: countryCode,
      isdCode: countryCallingCode,
      name: countryNameEn,
      localName: countryNameLocal,
      flagUrl: getCountryFlagUrl(countryCode),
    });
  }
  return countries;
}
